<template>
  <button
    class="u-button"
    type="button"
    :disabled="disabled || loading"
    @click="handleClick"
    :class="[
      type ? 'u-button_' + type : '',
      {
        'is-automatic': automatic,
        'is-round': round,
        'is-circle': circle,
        'is-disabled': disabled,
        'is-loading': loading,
      },
    ]"
  >
    <i class="u-icon-loading" v-if="loading"></i>
    <i class="u-button_icon" :class="icon" v-if="icon && !loading"></i>
    <span v-if="$slots.default"><slot></slot></span>
  </button>
</template>
<script>
export default {
  name: 'UButton',
  componentName: 'UButton',
  /**
   * inheritAttrs默认值true,继承所有的父组件属性（除props的特定绑定）作为普通的HTML特性应用在子组件的根元素上，<div class="u-input">
   * inheritAttrs: false 组件的根元素不会继承特性设置,但是class属性会继承<div class="u-input" placeholder="最多输入10个字" maxlength="10">
   */
  inheritAttrs: false,
  data() {
    return {};
  },
  props: {
    type: {
      type: String,
      default: 'default',
    },
    icon: String,
    automatic: Boolean,
    round: Boolean,
    circle: Boolean,
    disabled: Boolean,
    loading: Boolean,
  },
  computed: {},
  methods: {
    handleClick() {},
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_public.scss';
/**************************按钮************************************/
.u-button {
  display: inline-block;
  color: $font-color;
  background: #fff;
  @include button-size(3.2rem, 0.8rem, $font-size, 0.8rem);
  border: 1px solid $border-color;
  text-align: center;
  white-space: nowrap;
  box-sizing: border-box;
  cursor: pointer;
  > span {
    display: inline-block;
    vertical-align: top;
  }
  &.u-button_default {
    @include button-type($main-color);
  }
  &.u-button_primary {
    color: #fff;
    background: $main-color;
    border-color: $main-color;
    @include button-type($main-color);
  }
  &.u-button_text {
    color: $main-color;
    background-color: transparent;
    border-color: transparent;
  }
  &.is-automatic {
    width: auto;
    height: auto;
    line-height: 1;
    padding: 0.24rem 0.4rem;
  }
  &.is-round {
    border-radius: 0.4rem;
  }
  &.is-circle {
    border-radius: 50%;
    width: 0.8rem;
    height: 0.8rem;
    padding: 0 0.18rem;
  }
}
.u-button-group {
  display: inline-block;
  vertical-align: middle;
  .u-button {
    float: left;
    position: relative;
    &:first-child {
      border-right-color: #fff;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:last-child {
      border-left-color: #fff;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    &:not(:first-child):not(:last-child) {
      border-left-color: #fff;
      border-right-color: #fff;
      border-radius: 0;
    }
    &:not(:last-child) {
      margin-right: -1px;
    }
  }
}
.u-icon-loading {
  background: url(./../../assets/img/icon/loading.png) no-repeat 0 center;
  background-size: 100%;
  width: 0.56rem;
  height: 100%;
  animation: rotateAni 1.5s linear infinite;
}
</style>
